'use client';

import { historyStackAtom } from '@/atom/historyStack';
import { DestinationCGType } from '@/types/graphql/root';
import { history } from '@/utils/history';
import { useSetAtom } from 'jotai';
import { usePathname } from 'next/navigation';

export default function DestMoveAndModifyInTripBottomBar({
  selectedDestIdList,
  destinations,
  onClickReplaceDestinationInDestSlot,
  setSelectDayForMoveDestVisible,
}: {
  selectedDestIdList: string[];
  destinations: DestinationCGType[];
  onClickReplaceDestinationInDestSlot: (dest: DestinationCGType) => void;
  setSelectDayForMoveDestVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const pathname = usePathname();
  const setHistoryStack = useSetAtom(historyStackAtom);

  return (
    <div
      className='max-w-[30rem] fixed bottom-0 z-10 w-full bg-white h-100pxr rounded-t-16pxr px-20pxr pt-16pxr pb-34pxr flex gap-8pxr'
      style={{
        boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.08)',
        transition: 'transform 0.2s ease-in-out',
        transform: selectedDestIdList.length > 0 ? 'translateY(0%)' : 'translateY(100%)',
      }}
    >
      <button
        className='px-16pxr py-14pxr border border-[#3177FF] rounded-8pxr flex items-center justify-center text-[#3177FF] w-full button-16-m gap-2pxr'
        onClick={() => {
          history?.push(pathname);
          setHistoryStack((prev) => [
            ...prev,
            {
              name: '[장소 이동] 장소선택 모달 종료 (from dest-move-and-modify-in-trip-bottom-bar.tsx)',
              afterAction: () => setSelectDayForMoveDestVisible(false),
            },
          ]);

          setSelectDayForMoveDestVisible(true);
        }}
      >
        장소 이동
        <div className='w-24pxr h-24pxr p-2pxr'>
          <div className='w-20pxr h-20pxr rounded-full bg-[#3177FF] text-white body-12-r relative'>
            <span className='absolute -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2'>
              {selectedDestIdList.length}
            </span>
          </div>
        </div>
      </button>
      <button
        className={`px-16pxr py-14pxr ${
          selectedDestIdList.length !== 1 ? 'bg-[#DEE0E1]' : 'bg-[#3177FF]'
        } rounded-8pxr flex items-center justify-center text-white w-full button-16-m`}
        disabled={selectedDestIdList.length !== 1}
        onClick={() => {
          const selectedDest = destinations.find((dest) => dest.id === selectedDestIdList[0]);
          if (selectedDest) {
            onClickReplaceDestinationInDestSlot(selectedDest);
          }
        }}
      >
        장소 교체
      </button>
    </div>
  );
}
